module.exports = __webpack_public_path__ + "static/levercode-pyramid-1449a05f2086a091a45085bd4c1820a8.png";